$(function () {
  var galleryThumbs = new Swiper(".product-thumbnail-slider", {
    direction: "horizontal",
    spaceBetween: 10,
    slidesPerView: 3,
    breakpoints: {
      0: {
        direction: "horizontal",
        slidesPerView: 3
      },
      480: {
        direction: "horizontal",
        slidesPerView: 3
      },
      767: {
        direction: "vertical",
        slidesPerView: 5
      },
      992: {
        direction: "vertical",
        slidesPerView: 6
      },
      1200: {
        direction: "vertical",
        slidesPerView: 7
      },
    }
  });
  var galleryTop = new Swiper(".product-main-image-slider", {
    direction: "horizontal",
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
  galleryTop.on("slideChangeTransitionStart", function () {
    galleryThumbs.slideTo(galleryTop.activeIndex);
  });
  galleryThumbs.on("transitionStart", function () {
    galleryTop.slideTo(galleryThumbs.activeIndex);
  });
});


// $(document).ready(function() {
//     $('.info-share-row-head').click(function() {
//       var $ul = $(this).siblings('.info-share-body');
//       $('.info-share-body').not($ul).slideUp();
//       $ul.slideToggle();
    
//       $('.info-share-row-head').not(this).removeClass('active-heading');
//       $(this).toggleClass('active-heading');
//     });
// });

let SwiperClients = new Swiper('.our-clients-slider', {
    spaceBetween: 24,
    centeredSlides: true,
    speed: 8000,
    autoplay: {
        delay: 1,
    },
    loop: true,
    // slidesPerView:'6',
    allowTouchMove: false,
    disableOnInteraction: true,
    breakpoints: {
        360: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 6,
            spaceBetween: 24,
        },
    },
});


var swiper = new Swiper(".best-seller-slider", {
    speed: 2000,
    spaceBetween: 24,
    // slidesPerView:'4',
    loop: true,
    allowTouchMove: true,
    mousewheel: false,
    keyboard: {
        enabled: true,
      },
    // autoplay: {
    //     delay: 1,
    // },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
      allowTouchMove: true,
    },

    breakpoints: {
        360: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 24,
  
      
           navigation:{
        nextEl: ".swiper-button-next-seller",
        prevEl: ".swiper-button-prev-seller",
      },
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 24,
           navigation:false,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
});





var swiper1 = new Swiper(".single-collection-slider", {
    speed: 3000,
    spaceBetween: 10,
    slidesPerView:'1',
    loop: false,
    allowTouchMove: true,
    // autoplay: {
    //     delay: 1,
    // },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});



var swiper2 = new Swiper(".my-carousel__swiper", {
    speed: 1500,
    loop: true,
    grabCursor: true,
    centeredSlides: true,
    mousewheel: false,
    centeredSlidesBounds: false,
    navigation: {
        nextEl: ".my-carousel__control--next",
        prevEl: ".my-carousel__control--prev",
    },
    // slidesPerView:4,
    breakpoints: {
        360: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        600: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 24,
        },
    },
    effect: "creative",
    spaceBetween: 0,
    keyboard: {
        enabled: true,
    },
    creativeEffect: {
      
      perspective: false,
      limitProgress: 5,
      prev: {
          translate: ['-90%', '20%', -100],
          rotate: [0, 0, -25],
          origin: "bottom"
      },
      next: {
          translate: ['90%', '20%', -100],
          rotate: [0, 0, 25],
          origin: "bottom"
      },
  },
});
 



var swiper3 = new Swiper(".testimonials-slider", {
    speed: 3000,
    spaceBetween: 20,
    slidesPerView: 1,
    loop: false,
    initialSlide: 2,
    allowTouchMove: true,
    // autoplay: {
    //     delay: 1,
    // },
    navigation: {
        nextEl: ".testimonials-button-next",
        prevEl: ".testimonials-button-prev",
    },
    breakpoints: {
        360: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 1.2,
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 1.6,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 1.8,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
    },
});




// if ($(window).width() <= 767 ) {
//     $('.footer-col-heading').on('click', function() {
//         var $this = $(this);
//         var $parentCol = $this.closest('.footer-top-menu-col');
//         var $allHeadings = $('.footer-col-heading');
//         var $allLists = $('.footer-top-menu');
    
//         // Toggle class for the clicked heading and remove from others
//         $allHeadings.not($this).removeClass('active');
//         $this.toggleClass('active');
    
//         // Slide up all lists except the one under the clicked heading's parent
//         $allLists.not($parentCol.find('.footer-top-menu')).slideUp();
    
//         // Slide toggle the list under the clicked heading's parent based on its current visibility
//         var $currentList = $parentCol.find('.footer-top-menu');
//         if ($currentList.is(':visible')) {
//             $currentList.slideUp();
//         } else {
//             $allLists.slideUp(); // Close all other lists
//             $currentList.slideDown();
//         }
//     });   
// }


// $('.header-hamburger').click(function () {
//     $('.header-nav').toggleClass('active');
//     $(this).toggleClass('active');
//     $('body').toggleClass('overflow-hide')
// })



$('.faq-question').on('click', function() {
    var $a_this = $(this);
    var $a_parentCol = $a_this.closest('.faq-accordion-single');
    var $a_allHeadings = $('.faq-question');
    var $a_allLists = $('.faq-answer');

    // Toggle class for the clicked heading and remove from others
    $a_allHeadings.not($a_this).removeClass('active');
    $a_this.toggleClass('active');

    // Slide up all lists except the one under the clicked heading's parent
    $a_allLists.not($a_parentCol.find('.faq-answer')).slideUp();

    // Slide toggle the list under the clicked heading's parent based on its current visibility
    var $a_currentList = $a_parentCol.find('.faq-answer');
    if ($a_currentList.is(':visible')) {
        $a_currentList.slideUp();
    } else {
        $a_allLists.slideUp(); // Close all other lists
        $a_currentList.slideDown();
    }
});   

var brandSwiper = new Swiper(".brand-partners-slider", {
    speed: 2000,
    spaceBetween: 20,
    slidesPerView: 1,
    loop: false,
    initialSlide: 2,
    allowTouchMove: true,
    navigation: {
        nextEl: ".brand-partner-next",
        prevEl: ".brand-partner-prev",
    },
    breakpoints: {
        360: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 1.2,
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 1.6,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 2.2,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 2.4,
            spaceBetween: 24,
        },
    },
});




var swiperThumbs = new Swiper(".wellness-journey-thumbs-slider", {
    spaceBetween: 5,
    slidesPerView: 2,
    freeMode: true,
    watchSlidesProgress: true,
    parallax: true,
    breakpoints: {
    360: {
        slidesPerView: 2,
        spaceBetween: 10,
    },
    600: {
        slidesPerView: 2,
        spaceBetween: 15,
    },
    768: {
        slidesPerView: 3,
        spaceBetween: 15,
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 20,
    },
    1200: {
        slidesPerView: 3,
        spaceBetween: 24,
    },
},
    thumbs: {
        swiper: swiperMain,
    },
});

var swiperMain = new Swiper(".wellness-journey-main-images-slider", {
    spaceBetween: 10,
    slidesPerView: 1,
    parallax: true,
    autoplay: {
        delay: 3000,
    },
    // pagination: {
    //     el: '.main-image-pagination',
    //     clickable: true,
    //     renderBullet: function (index, className) {
    //     return '<div class="' + className + '">' + (menu[index]) + '</div>';
    //     },
    // },
    pagination: {
        el: '.main-image-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<div class="' + className + '">' + (menu[index]) + '</div>';
        },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiperThumbs,
    },
});

// Handling click event for anchor tags inside pagination bullets to open links in new tab/window
document.querySelectorAll('.swiper-pagination-link').forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        var url = this.getAttribute('href');
        window.open(url, '_blank');
    });
});


// $('.navigation__menuitem--dropdown a').click(function () {
//     // e.preventDefault();
//     $(this).siblings('.megamenu').slideToggle('slow');
// });
$(document).ready(function(){
  if ($(window).width() < 1200) {
$('.navigation__menuitem--dropdown').append("<span class='mob-arrow'><img src='https://cdn.shopify.com/s/files/1/0591/9965/2025/files/icons8-expand_arrow_1.svg?v=1701874001' alt=''></span>");
}
});

$(document).ready(function () {
  if ($(window).width() < 1200) {
  $('.mob-arrow').click(function(){
    $(this).siblings('ul.megamenu').slideToggle().parent().siblings().children('ul.megamenu').slideUp();
  });
    }
});
$(document).ready(function () {
  var swiperb = new Swiper(".header-top-bar", {
    spaceBetween: 0,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 12000,
    autoplay: {
        delay: 1,
    },
    loop: true,
    // slidesPerView:'6',
    allowTouchMove: false,
    disableOnInteraction: true,

});
});
 $(document).ready(function() {
   setTimeout(function() {
      var priceItem = $('span.price-item.price-item--sale');
      var originalText = priceItem.text();
      var correctedText = originalText.replace('$7,000.00', '$7000.00');
      priceItem.text(correctedText);
       }, 4000);
    });


